import { WrappedFieldMetaProps } from 'redux-form';

export const mapError = (meta: WrappedFieldMetaProps, errorProp = 'errorText', show = false) =>
  meta && (meta.touched || meta.visited || show) && (meta.error || meta.warning)
    ? { [errorProp]: meta.error || meta.warning }
    : {};
